import React, { useContext, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Snackbar,
  Typography,
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import ReactCountryFlag from "react-country-flag";
import { isEmpty, isEqual, kebabCase } from "lodash";
import { Alert } from "@material-ui/lab";
import { NotificationContainer } from "react-notifications";

import DetailedMenuView from "./detailed-menu-view";
import MaleIcon from "../../../../../../images/groom.png";
import FemaleIcon from "../../../../../../images/bride.png";
import userIcon from "../../../../../../images/user.png";
import "./style.css";
import Config from "../../../../../../config";
import {
  UserListAdvertisementContext,
  UserListContext,
} from "../../../../../../context/follow-up-widgets";
import PageDomain from "../../domain";

const { REACT_APP_WEB_URL } = Config;

const DataTagItem = ({
  label = "",
  value = "",
  allowClipboard = false,
  href,
  variant = "square",
  className = "",
  startIcon,
}) => {
  const url = !isEmpty(href) ? URL.parse(href) : null;
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);

  return (
    <Typography
      variant="body2"
      className={`data-tag-item item-${variant} ${className}`}
      onClick={(e) => e.stopPropagation()}
      style={{ cursor: "default" }}
    >
      <span className="label">
        {url instanceof URL && (
          <i class="link-icon bi bi-box-arrow-up-right"></i>
        )}
        {React.isValidElement(startIcon) && (
          <span className="pr-1">{startIcon}</span>
        )}
        {label}
      </span>
      <span className="value">
        {value}
        {allowClipboard && (
          <i
            class="copy-icon bi bi-clipboard"
            onClick={() => {
              navigator.clipboard.writeText(value);
              setShowSuccessAlert(true);
            }}
            style={{ cursor: "pointer" }}
          />
        )}
      </span>
      <Snackbar
        open={showSuccessAlert}
        autoHideDuration={2000}
        onClose={() => setShowSuccessAlert(false)}
      >
        <Alert severity="success" onClose={() => setShowSuccessAlert(false)}>
          Copied to clipboard.
        </Alert>
      </Snackbar>
    </Typography>
  );
};

const AdSummeryListitem = ({ advertisement }) => {
  const { sideViewInfo, setSideViewInfo } = useContext(UserListContext);

  const [isExpanded, setIsExpanded] = useState(false);

  const values = PageDomain.formatUserData({
    userData: advertisement,
  });

  const profileAvatar =
    advertisement.post?.gender === "MALE"
      ? MaleIcon
      : advertisement.post?.gender === "FEMALE"
        ? FemaleIcon
        : userIcon;

  const onClickAccordion = () => {
    if (isEmpty(sideViewInfo)) {
      return;
    }
    if (
      sideViewInfo.open &&
      sideViewInfo.advertisement.memberId !== advertisement.memberId
    ) {
      setSideViewInfo({});
    }
  };

  return (
    <Accordion
      elevation={0}
      className="accordian-list-item"
      onClick={onClickAccordion}
      onChange={(e, expanded) => setIsExpanded(expanded)}
    >
      <UserListAdvertisementContext.Provider value={{ advertisement }}>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Grid container direction="row" className="gap-x-8">
            <img
              src={profileAvatar}
              alt="profile-avatar"
              height={50}
              style={{ border: "solid 1px #cca326", borderRadius: "50%" }}
            />
            <Grid xs container direction="column" className="gap-y-16">
              <Grid
                item
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid container direction="column" className="gap-y-8">
                  <Grid
                    item
                    container
                    direction="row"
                    className="gap-x-8 gap-y-8"
                    alignItems="center"
                    justifyContent="flex-start"
                  >
                    <Typography variant="body1">{values.fullName}</Typography>
                    {/* <ReactCountryFlag countryCode={residentCountry} /> */}
                    <a
                      href={`${REACT_APP_WEB_URL}/post?id=${advertisement.post?.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i
                        class="bi bi-link-45deg"
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      />
                    </a>
                  </Grid>
                  <Grid item container direction="row" className="gap-x-8">
                    <DataTagItem
                      variant="rounded"
                      label="member id"
                      value={values.memberId}
                      allowClipboard={true}
                      href={values.href}
                    />
                    <DataTagItem
                      variant="rounded"
                      label="post Id"
                      value={values.postId}
                      allowClipboard={true}
                      href={values.href}
                    />
                    <DataTagItem
                      variant="rounded"
                      label="phone number"
                      value={values.phoneNumber}
                      allowClipboard={true}
                      startIcon={<i class="bi bi-telephone-fill"></i>}
                    />
                    <DataTagItem
                      variant="rounded"
                      label="email"
                      value={values.email}
                      allowClipboard={true}
                      startIcon={<i class="bi bi-envelope"></i>}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                container
                direction="row"
                justifyContent="space-between"
                className="gap-x-16"
              >
                <Grid
                  item
                  xs={6}
                  container
                  direction="row"
                  alignItems="flex-start"
                  className="gap-x-8 gap-y-8"
                >
                  <DataTagItem
                    label="profile status"
                    value={values.status}
                    className={`status-${kebabCase(values.status)}`}
                  />
                  <DataTagItem
                    label="package"
                    value={values.pricingTier}
                    className={`pricing-tier-${kebabCase(values.pricingTier)}`}
                  />
                  <DataTagItem
                    label="subscription status"
                    value={values.subscriptionStatus}
                    className={`subscription-status-${kebabCase(
                      values.subscriptionStatus,
                    )}`}
                  />
                  <DataTagItem label="age" value={values.age} />
                  <DataTagItem
                    label="civil status"
                    value={values.civilStatus}
                  />
                  <DataTagItem
                    label="Resident Country"
                    value={values.residentCountry}
                  />
                </Grid>
                <Grid
                  item
                  xs
                  container
                  direction="row"
                  className="gap-y-8 h-fit"
                  alignItems="flex-start"
                >
                  <Grid
                    item
                    container
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="flex-start"
                    className="gap-x-8 gap-y-8"
                  >
                    <DataTagItem
                      variant="square"
                      label="created date"
                      value={values.createdAt}
                    />
                    <DataTagItem
                      variant="square"
                      label="latest published date"
                      value={values.publishedAt}
                    />
                  </Grid>
                  <Grid
                    item
                    container
                    direction="row"
                    justifyContent="flex-end"
                    className="gap-x-8"
                  >
                    <DataTagItem
                      variant="square"
                      label="first published date"
                      value={values.firstPublishedAt}
                    />
                    <DataTagItem
                      variant="square"
                      label="expiring date"
                      value={values.expiresAt}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          {isExpanded && <DetailedMenuView advertisement={advertisement} />}
        </AccordionDetails>
      </UserListAdvertisementContext.Provider>
      <NotificationContainer />
    </Accordion>
  );
};

export default React.memo(AdSummeryListitem, (prevProps, newProps) => {
  return isEqual(prevProps, newProps);
});
